import { ComputedRef } from '@vue/composition-api';
import { userReportBehavior } from '../api/issue';

export const useReport = (isVisitor: ComputedRef<boolean>) => {
  const onUserBehavior = async (params: Object) => {
    if (!isVisitor.value) {
      await userReportBehavior(params);
    }
  };

  return {
    onUserBehavior
  };
};

export type ReportStore = ReturnType<typeof useReport>;
